// extracted by mini-css-extract-plugin
export var clone = "_vg-2";
export var displayNone = "_vg-4";
export var expandableItem = "_vg-5";
export var expanded = "_vg-6";
export var folderItem = "_vg-7";
export var ghost = "_vg-1";
export var hidden = "_vg-3";
export var pipeContainer = "_vg-8";
export var wrapper = "_vg-0";